/* Ayudate · Tarifas y comisión */


/* Mercado abierto: cada tutor pone su tarifa en cada curso. Al estudiante se le
   cobra un 10% más y al tutor se le descuenta un 10%, redondeado a los ₡100 más
   cercanos. La plataforma gana 10% de cada lado.                              */
export const TARIFA_MINIMA = 3000;
export const TARIFA_SUGERIDA = 5000;

export const r100 = (n) => Math.round(n / 100) * 100;

export const precioDe = (base) => {
  const b = Number(base) || 0;
  return { cliente: r100(b * 1.1), tutor: r100(b * 0.9) };
};

export const tarifas = (t) => ({ cliente: t.tarifaCliente, tutor: t.tarifaTutor });

/* Ejemplo que se usa en las políticas y en la sección de tutores. */
export const EJ = precioDe(TARIFA_SUGERIDA);
